import { useCallback, useContext, useMemo, useState } from "react";
import { CloseShiftProcessContext, EndOfShiftContext } from "./context";
import {
  CloseShiftContextType,
  CloseShiftPayment,
  CloseShiftPaymentCount,
  UseCloseShiftProcessOptions,
} from "./type";

export const useEndOfShiftContextProvider = () => {
  const context = useContext(EndOfShiftContext);
  if (context === undefined) {
    throw new Error(
      "useEndOfShiftContextProvider must be used within a EndOfShiftContextProvider"
    );
  }
  return context;
};

export const useCloseShiftProcess = ({
  paymentMethodIds,
}: UseCloseShiftProcessOptions): CloseShiftContextType => {
  const [note, setNote] = useState<string | undefined>(undefined);
  const [nextOpeningFloat, setNextOpeningFloat] = useState<number | undefined>(
    undefined
  );

  const [payments, setPayments] = useState<CloseShiftPaymentCount[]>(
    paymentMethodIds.map((p) => ({
      ...p,
      counted: undefined,
    }))
  );

  const countPaymentMethod = (
    paymentMethodId: string,
    amount: number
  ): CloseShiftPayment | undefined => {
    const newPayments = payments.map((payment) => {
      if (payment.paymentMethodId === paymentMethodId) {
        return {
          ...payment,
          counted: amount,
        };
      }
      return payment;
    });
    setPayments(newPayments);
    const nextPayment = newPayments.find(
      (payment) => payment.counted === undefined
    );
    return nextPayment;
  };

  const getNextPaymentMethod = useCallback(() => {
    const nextPayment = payments.find(
      (payment) => payment.counted === undefined
    );
    console.log("next payment method", nextPayment)
    return nextPayment;
  }, [payments]);

  const isCountingComplete = useMemo(() => {
    const nextPaymentMethod = getNextPaymentMethod();
    return nextPaymentMethod === undefined; // no more payment method to count
  }, [payments]);

  return {
    note,
    isCountingComplete,
    nextOpeningFloat,
    payments,
    setNote,
    setNextOpeningFloat,
    countPaymentMethod,
    getNextPaymentMethod,
  };
};

export const useCloseShiftProcessProvider = () => {
  const context = useContext(CloseShiftProcessContext);
  if (context === undefined) {
    throw new Error(
      "useCloseShiftProcessProvider must be used within a CloseShiftProcessProvider"
    );
  }
  return context;
};
